import CreatorProfile from "./CreatorProfile";

export default function ClaudiaGProfile() {
  return (
    <CreatorProfile
      creatorId={10}
      categoryLabel="Lifestyle Creator"
      onlyMemberzSlug="claudiaglifestyle"
      tags={["Lifestyle", "BTS", "Luxury", "Series", "TTTA"]}
    />
  );
}
